// extracted by mini-css-extract-plugin
module.exports = {"title":"_7a3fb80146--title--X5SYA"};